module.exports = __webpack_public_path__ + "@/assets/img/matricula.f0bc34c8.png";